import {Quest} from "./quest.ts";

export type User = {
    id: `${string}-${string}-${string}-${string}-${string}`;
};

function saveUser(user: User) {
    localStorage.setItem("user", JSON.stringify(user));
}

function loadUser(): User | null {
    const userJson = localStorage.getItem("user");
    if (userJson) {
        return JSON.parse(userJson) as User;
    }
    return null;
}


function createUser(): User {
    const user = {
        id: crypto.randomUUID(),
    }
    saveUser(user);
    return user;
}

export function getUser(): User {
    return loadUser() ?? createUser();
}

export function getAllQuests(user: User): Quest[] {
    return [];
}
